import mixpanelCommonEvents from 'top20common/distribution/plugins/mixpanel';
import analyticsCommon from 'top20common/distribution/services/analytics/common';

import auth from './events.auth';

export default function(multianalytics) {
  const analytics = analyticsCommon(multianalytics);

  analytics.trackSavedSearchDeleted = function() {
    analytics.trackEvent({action: 'Saved Search Deleted'});
  };

  analytics.trackBackToApplicationClicked = function(target) {
    analytics.trackEvent({
      action: 'Back to Application Clicked',
      properties: {
        target
      }
    });
  };

  analytics.trackCoISaved = function(coi) {
    analytics.trackEvent({
      action: 'Companies of Interest Saved',
      properties: {
        Count: coi.length,
        Companies: coi.join(', ')
      }
    });
  };

  analytics.trackNewCoIAdded = function(company) {
    analytics.trackEvent({
      action: 'Companies of Interest Added',
      properties: {
        Company: company
      }
    });
  };

  analytics.trackCoISelected = function(company) {
    analytics.trackEvent({
      action: 'Companies of Interest Selected',
      properties: {
        Company: company
      }
    });
  };

  analytics.trackForgotPasswordClicked = function() {
    analytics.trackEvent({action: 'Forgot Password Clicked'});
  };

  analytics.trackNextFactClicked = function() {
    analytics.trackEvent({action: 'Next Fact Clicked'});
  };

  return {
    ...analytics,
    ...mixpanelCommonEvents(analytics),
    ...auth(analytics)
  };
}
